import type { EventName } from "@lit/react";
import { ContextMenu as ContextMenuElement, type ContextMenuEventMap as _ContextMenuEventMap, } from "@vaadin/context-menu/vaadin-context-menu.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { ContextMenuElement, };
export type ContextMenuEventMap = Readonly<{
    onCloseAllMenus: EventName<_ContextMenuEventMap["close-all-menus"]>;
    onClosed: EventName<_ContextMenuEventMap["closed"]>;
    onItemSelected: EventName<_ContextMenuEventMap["item-selected"]>;
    onItemsOutsideClick: EventName<_ContextMenuEventMap["items-outside-click"]>;
    onOpenedChanged: EventName<_ContextMenuEventMap["opened-changed"]>;
}>;
const events = { onCloseAllMenus: "close-all-menus", onClosed: "closed", onItemSelected: "item-selected", onItemsOutsideClick: "items-outside-click", onOpenedChanged: "opened-changed" } as ContextMenuEventMap;
export type ContextMenuProps = WebComponentProps<ContextMenuElement, ContextMenuEventMap>;
export const ContextMenu = createComponent({
    elementClass: ContextMenuElement, events, react: React, tagName: "vaadin-context-menu"
});
